import InnerComponent from '@Components/Inventory/PreviewCart';
import orgContainer from '@Components/AppContainer';

const PreviewCart = () => ((orgContainer(InnerComponent)));
export default PreviewCart;
